// The card frame: outer wrapper, header hats, close button, expanded area and
// message box. The header has three hats on TGS/TES (title, sibling, ate) and
// two on ESS (title, ate); `hasSibling` picks the matching widths, `sizeStep` is
// machineCardFacts' titleSize (0, 1 or 2).
import styled, { css } from 'styled-components';

import { flexBoxCenter, justifyContentFlexEnd, layerA180Deg, layerB } from '../styles/commonStyles';

const HEADER = {
  withSibling: {
    padLeft: 24,
    mobilePadRight: 40,
    row: [608, 920, 1084],
    title: [396, 624, 844],
    hatWidth: 100,
    hatPadRight: 34,
  },
  withoutSibling: {
    padLeft: 42,
    mobilePadRight: 50,
    row: [488, 920, 1000],
    title: [388, 610, 900],
    hatWidth: 96,
    hatPadRight: 14,
  },
};
const geometry = (p) => HEADER[p.hasSibling ? 'withSibling' : 'withoutSibling'];

export const Wrapper = styled.div`
  ${(p) =>
    p.isMobile
      ? css`
          width: 311px;
          height: 108px;
          ${p.isFaults &&
          css`
            border: 1px solid red;
          `}
        `
      : css`
          width: 1205px;
          height: 108px;
          position: relative;
        `}

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${(p) =>
    p.isExpanded &&
    css`
      height: auto;
    `};
`;

export const SectionHeader = styled.section`
  width: 100%;
  padding-left: ${(p) => geometry(p).padLeft}px;
  display: flex;
  justify-content: space-between;
  position: relative;

  ${(p) =>
    p.isMobile &&
    css`
      ${justifyContentFlexEnd}
      padding-right: ${geometry(p).mobilePadRight}px;
    `}
`;

export const SectionHeaderWrapper = styled.div`
  width: 50%;
  display: flex;
  ${(p) =>
    p.right
      ? css`
          width: ${geometry(p).row[p.sizeStep]}px;
          justify-content: space-between;
        `
      : css`
          justify-content: flex-end;
          position: relative;
        `};

  ${(p) =>
    p.isExpanded ||
    css`
      visibility: hidden;
    `}
`;

export const HoverBox = styled.div`
  width: auto;
  height: auto;
  position: absolute;

  ${flexBoxCenter}

  bottom: 32px;
  left: 0;
  z-index: 100;

  display: none;
`;

export const HeaderHat = styled.div`
  background: url(${(p) => p.imgSrc}) no-repeat;
  display: flex;
  align-items: center;
  ${(p) =>
    p.isMobile
      ? css`
          height: 20px;
          width: 52px;
          padding-left: 6px;
          ${p.first &&
          css`
            margin-right: 6px;
          `}
        `
      : css`
          height: 31px;
          ${p.first
            ? css`
                &:hover ${HoverBox} {
                  display: inline;
                }
                width: ${geometry(p).title[p.sizeStep]}px;
                padding-left: 4px;
              `
            : p.second
              ? css`
                  width: ${geometry(p).hatWidth}px;
                  justify-content: center;
                  padding-right: ${geometry(p).hatPadRight}px;
                `
              : css`
                  width: 122px;
                  justify-content: center;
                  padding-left: 20px;
                `};
        `}
`;

export const HeaderTitle = styled.span`
  margin-left: ${({ isMobile }) => !isMobile && '8px'};
  font-size: ${(p) => (p.isMobile ? '10px' : '14px')};
  letter-spacing: ${(p) => (p.isMobile ? '1.0px' : '1.4px')};
  color: ${({ isSwitch }) => (isSwitch ? '#fcff01' : '#fff')};

  overflow: hidden;
`;

export const HeaderButton = styled.button`
  width: 88px;
  height: 25px;
  border-radius: 18px;
  ${layerB}
  ${flexBoxCenter}

  position: absolute;
  top: 3px;
  right: 3px;
`;
export const HeaderButtonOuter = styled.div`
  width: 86px;
  height: 23px;
  border-radius: 25px;
  ${layerA180Deg}
  ${flexBoxCenter}
`;
export const HeaderButtonHole = styled.div`
  width: 78px;
  height: 15px;
  border-radius: 18px;

  ${layerB}
  ${flexBoxCenter}
`;
export const HeaderButtonTop = styled.div`
  width: 76px;
  height: 13px;
  border-radius: 25px;
  font-size: 7px;
  ${layerA180Deg}
  ${flexBoxCenter}
`;

export const SectionMainContentExpand = styled.div`
  width: 1205px;
  ${flexBoxCenter}

  ${(p) =>
    p.isMobile &&
    css`
      width: 100%;
      margin-top: 6px;
    `}
`;

export const MessageBoxWrapper = styled.div`
  width: 34%;
  height: 190px;
  position: absolute;

  ${flexBoxCenter}

  top: 0;
  left: 0;
  z-index: 100;
`;
